import { title, grayColor } from "../../../material-kit-pro-react";
import { createStyles } from "@material-ui/core";

const productStyle = createStyles({
  section: {
    padding: "70px 0",
    textAlign: "center"
  },
  title: {
    ...title,
    marginBottom: "1rem",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none"
  },
  description: {
    color: grayColor[0]
  }
});

export default productStyle;
